const labelOptions = [
    {
        id: 1,
        value: "thoughts"
    },
    {
        id: 2,
        value: "shopping"
    },
    {
        id: 3,
        value: "work"
    },
    {
        id: 4,
        value: "todo"
    }
]

export default labelOptions;